import styled from "styled-components";

export const Container: any = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  margin-top: 16px;
  padding: 16px;
  width: 100%;
  min-height: 76px;
  background-color: ${(props: any) => props.backgroundColor || "#2d5bff"};
  border: ${(props: any) => props.border || "none"};
`;

export const InfoChecklist = styled.div`
  display: flex;
  align-items: center;
  min-width: 262px;
  height: 42px;
  padding: 8px 16px;
  background-color: #ffff;
  border-radius: 8px;
`;

export const TitleChecklist = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: right;
  color: #646363;
`;

export const TitleButtonChecklist = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: #ffffff;
`;

export const Title = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  text-align: left;
  color: ${(props: any) => props.color || "#2d5bff"};
`;

export const TextDescription = styled.p`
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
  line-height: 14px;
  text-align: left;
  color: ${(props: any) => props.color || "#2d5bff"};
`;

export const WhiteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 42px;
  padding: 8px 14px;
  border-radius: 8px;
  background-color: #ffffff;
  :hover {
    cursor: pointer;
  }
  :disabled {
    cursor: not-allowed;
  }
`;

export const Button: any = styled.button`
  display: flex;
  width: ${(props: any) => props.width || "100%"};
  height: ${(props: any) => props.height || "100%"};
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 8px 0;
  border-radius: 8px;
  border: ${(props: any) => (props.border ? props.border : "none")};
  background-color: ${(props: any) => props.color || "#2d5bff"};
  :hover {
    cursor: pointer;
  }
  :disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space || 8}px;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space || 8}px;
`;
